<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7zj400/tc-custom/9781452100166.jpg?1718106413325" alt="This image is the cover for the book Fast Breads"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fast Breads
      </h1>
      <p class="bookDescription body article font2">
        <b>The master baker is back with the finest no-fuss recipes for homemade breads of all kinds—from crusty artisanal bread to biscuits, babka and more!</b><br/><br/>Best-selling author and baking authority Elinor Klivans presents sixty-five quick and simple recipes for irresistibly delicious homemade breads. With her easy-to-master techniques, anyone can whip up such delightful treats as Apricot Corn Muffins, Anytime Butter Twists, and Buttermilk Corn Bread, plus really super-fast favorites like Pumpkin Chocolate Chip Pancakes and Very Big Popovers, all with a minimum of sweat in the kitchen. <br/><br/>From morning treats like crumpets, muffins, and sticky breads to savory and nutritious multigrains and dark ryes, <i>Fast Breads</i> will make any novice baker into a master bread maker!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elinor Klivans, Susie Cushner
      </h2>
      
      <p class="authorDescription body article">Elinor Klivans is the best-selling author of many cookbooks, including <I>Cupcakes</I> and <I>Chocolate Cakes</I>. She lives in Camden, Maine.<br/><br/>Susie Cushner is a food and travel photographer living in New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b292665